/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import"../../core/units.js";import"./support/apiConverter.js";export{e as execute,s as supportsCurves}from"../../chunks/areaOperator.js";
